import { pipe } from 'ramda';

import { User } from '@/api/auth';
import { BonusType, CMSBonus } from '@/api/cms/bonuses';
import {
  filterByBonusType,
  filterByGroupAndDuration,
  filterBySchedule,
  filterByToggle,
  sortByOrder,
} from '@/helpers/cms';

export const filterBonusesByGroups = (
  bonuses: CMSBonus[],
  toggleType: 'cashierToggle' | 'promoPageToggle' | 'termsAndConditionsToggle',
  bonusTypeOffer: BonusType,
  user?: User
) =>
  pipe(
    filterByGroupAndDuration<CMSBonus>({ user }),
    filterByToggle(toggleType),
    sortByOrder,
    filterBySchedule,
    filterByBonusType(bonusTypeOffer)
  )(bonuses);
